import { FC, useEffect } from "react";
import s from "./Index.module.scss";
import { Player } from "../../widgets";
import { Interface } from "../../widgets/Interface/Interface";
import { ModalFrame } from "../../processes/modals/ModalFrame/ModalFrame";
import { MobileHint } from "../../shared/MobileHint/MobileHint";
import WebSocketComponent from "../../features/WebSocketComponent/WebSocketComponent";
import { LeftPanelBar } from "../../widgets/LeftPanelBar/LeftPanelBar";
import { setCSSGlobalVariable } from "../../utils/functions/setCSSGlobalVariable";
import { useAuthInterval } from "../../utils/hooks/useAuthInterval";
import { getUserInformationThunk } from "../../redux/reducers/user/userThunks";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { useCameraPresets } from "../../hooks/useCameraPresets";
import { getCurrentTemplate } from "../../redux/reducers/ui/uiSelectors";
import { ProjectService } from "../../services/ProjectService";
import { EnvironmentService } from "../../services/EnvironmentService";

export const App: FC = () => {
  const dispatch = useAppDispatch();
  const currentTemplate = useAppSelector(getCurrentTemplate);
  useAuthInterval();

  // Initialize projectID in window SYNCHRONOUSLY before child components render
  if (!(window as any).projectID) {
    const projectID = ProjectService.getProjectID();
    (window as any).projectID = projectID ?? 1;
  }

  const {
    presets,
    activePreset,
    setActivePreset,
    deletePreset,
    savePreset,
    loadPresets,
  } = useCameraPresets(currentTemplate?.id);

  useEffect(() => {
    dispatch(getUserInformationThunk()).unwrap();
    setCSSGlobalVariable("interface", "width", "interfaceWidth");
    // Ensure environments are fetched on initial load, regardless of sidebar state
    EnvironmentService.fetchEnvironments(dispatch);
  }, []);

  return (
    <>
      <div className={`${s.wrapper} studio-wrapper`}>
        <LeftPanelBar />
        <Player
          presets={presets}
          activePreset={activePreset}
          setActivePreset={setActivePreset}
          deletePreset={deletePreset}
          savePreset={savePreset}
          loadPresets={loadPresets}
        />
        <Interface />
        <ModalFrame savePreset={savePreset} loadPresets={loadPresets} />
        <WebSocketComponent />
      </div>
      <MobileHint />
    </>
  );
};
